// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as SuspensionRepoConfig from "./SuspensionRepoConfig.bs.js";
import * as CommonRepoConfig$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/CommonRepoConfig.bs.js";

var dummyInfoResponse = {
        "status": 200,
        "suspension_info": {
          "suspend_status": "NOT_SUSPENDED",
          "driver_suspension_history": [
            {
              "event_mode": "MANUAL",
              "event_time": "09 July 2022, 08:16",
              "expiry_time": null,
              "reason": "Low Wallet Balance",
              "comment": "Wallet balance is above suspension balance",
              "event": "NOT_SUSPENDED",
              "administrator": null
            },
            {
              "event_mode": "MANUAL",
              "event_time": "09 July 2022, 08:16",
              "expiry_time": "22 March 2022, 13:39",
              "reason": "Low Wallet Balance",
              "comment": "Low Wallet Balance",
              "event": "SUSPENDED",
              "administrator": null
            },
            {
              "event_mode": "MANUAL",
              "event_time": "09 July 2022, 08:16",
              "expiry_time": null,
              "reason": "Low Wallet Balance",
              "comment": "Wallet balance is above suspension balance",
              "event": "NOT_SUSPENDED",
              "administrator": null
            },
            {
              "event_mode": "MANUAL",
              "event_time": "09 July 2022, 08:16",
              "expiry_time": "22 March 2022, 12:40",
              "reason": "Low Wallet Balance",
              "comment": "Low Wallet Balance",
              "event": "SUSPENDED",
              "administrator": null
            },
            {
              "event_mode": "MANUAL",
              "event_time": "09 July 2022, 08:16",
              "expiry_time": null,
              "reason": "Low Wallet Balance",
              "comment": "Wallet balance is above suspension balance",
              "event": "NOT_SUSPENDED",
              "administrator": null
            },
            {
             "event_mode": "MANUAL",
              "event_time": "09 July 2022, 08:16",
              "expiry_time": "21 March 2022, 18:02",
              "reason": "N/A",
              "comment": "vcnhgjh",
              "event": "NOT_SUSPENDED",
              "administrator": "amrutha@xyz.com"
            },
            {
              "event_mode": "MANUAL",
              "event_time": "09 July 2022, 08:16",
              "expiry_time": "21 March 2022, 18:01",
              "reason": "Low Wallet Balance",
              "comment": "Low Wallet Balance",
              "event": "SUSPENDED",
              "administrator": null
            }
          ]
        }
      };

var dummyReasonResponse = {"result":[
        {
          "id":9,
          "description":"Driver Suspended due to breach in Monthly Suspension Threshold",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "1 Day",
              "hours": 24
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        },
        {
          "id":8,
          "description":"No order for last 15 days",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "1 Day",
              "hours": 24
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        },
        {
          "id":7,
          "description":"Not reachable for last 5 consecutive times",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        },
        {
          "id":6,
          "description":"Not Logged in for last 15 days",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        },
        {
          "id":5,
          "description":"Driver left and owner to find a new driver",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        },
        {
          "id":4,
          "description":"Inappropriate behavior",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        },
        {
          "id":3,
          "description":"Vehicle breakdown",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        },
        {
          "id":2,
          "description":"Driver is very rude",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        },
        {
          "id":1,
          "description":"Driver is not punctual",
          "suspension_durations": [
            {
              "tag": "1 Hr",
              "hours": 1
            },
            {
              "tag": "1 Day",
              "hours": 24
            },
            {
              "tag": "Indefinite",
              "hours": null
            }
          ]
        }
      ]};

var dummySuspendPartnerResponse = {
        "status": 200,
        "message": "The driver has been suspended"
      };

var dummyUnsuspendPartnerResponse = {
        "status": 200,
        "message": "The driver has been unsuspended"
      };

function fetchSuspensionInfo(_msisdn, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyInfoResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SuspensionRepoConfig.SuspensionInfoResponseConverter.execute, result);
                        });
            });
}

function fetchSuspensionReasons(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyReasonResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SuspensionRepoConfig.SuspensionReasonsResponseConverter.execute, result);
                        });
            });
}

function suspendPartner(_msisdn, _reason, _comment, _hours, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummySuspendPartnerResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

function unsuspendPartner(_msisdn, _comment, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyUnsuspendPartnerResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

var SuspensionRepo = {
  dummyInfoResponse: dummyInfoResponse,
  dummyReasonResponse: dummyReasonResponse,
  dummySuspendPartnerResponse: dummySuspendPartnerResponse,
  dummyUnsuspendPartnerResponse: dummyUnsuspendPartnerResponse,
  fetchSuspensionInfo: fetchSuspensionInfo,
  fetchSuspensionReasons: fetchSuspensionReasons,
  suspendPartner: suspendPartner,
  unsuspendPartner: unsuspendPartner
};

export {
  SuspensionRepo ,
  
}
/* SuspensionRepoConfig Not a pure module */
